

/*  CONTENT TYPES VIEWS */
const addonContentTypesViews = {
  // SchedaPersona: SchedaPersonaWrapperView,
  // LRF: HomeView,
  // Struttura: StrutturaView,
  // "Plone Site": HomeView,
  // Document: PageView,
  // 'News Item': NewsItemView,
};

/* LAYOUT VIEWS */
const addonLayoutViews = {
  // rubrica_view: HomeView,
  // document_view: PageView,
};

const layoutViewsNamesMapping = {
  // rubrica_view: 'Vista Rubrica',
  // modulistica_view: 'Cartella modulistica',
};

const getAddonViews = (config) => {
  return {
    contentTypesViews: {
      ...config.views.contentTypesViews,
      ...addonContentTypesViews,
    },
    layoutViews: {
      ...config.views.layoutViews,
      ...addonLayoutViews,
    },
    layoutViewsNamesMapping: {
      ...config.views.layoutViewsNamesMapping,
      ...layoutViewsNamesMapping,
    },
  };
};

export default getAddonViews;
